/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { liquidModeViewState } from "constants/enums";

/**
 * Variable names, imports and methods added to this class should be placed in
 * alphabetical order for uniformity.
 */

export const getLiquidModeIframeSrc = stores => stores.liquidModeViewStore.liquidModeIframeSrc;

export const getLiquidModeViewError = stores => stores.liquidModeViewStore.error;

export const getLiquidModeViewLoaded = stores => stores.liquidModeViewStore.viewState === liquidModeViewState.LOADED;

export const getLiquidModeViewReady = stores => stores.liquidModeViewStore.viewState === liquidModeViewState.READY;

export const getNetworkProxyReady = stores => stores.liquidModeViewStore.networkProxyReady;

export const getNetworkProxyTechnology = stores => stores.liquidModeViewStore.networkProxyTechnology;

export const getServiceWorkerScope = stores => stores.liquidModeViewStore.serviceWorkerScope;

export const getShowWaitView = stores => stores.liquidModeViewStore.viewState === liquidModeViewState.LOADING;

export const getViewState = stores => stores.liquidModeViewStore.viewState;

export const isDocumentInLiquidMode = stores => {
  const viewState = getViewState(stores);
  return viewState && viewState !== liquidModeViewState.EXITED;
};

export const isFileQualified = stores => stores.liquidModeViewStore.isFileQualified;

export const isLiquidModeViewEnabled = stores => stores.liquidModeViewStore.isLiquidModeViewEnabled;

export const setNetworkProxyReady = stores => flag => {
  stores.liquidModeViewStore.setNetworkProxyReady(flag);
};

export const setNetworkProxyTechnology = stores => networkProxyTechnology => {
  stores.liquidModeViewStore.setNetworkProxyTechnology(networkProxyTechnology);
};

export const setViewState = stores => state => {
  stores.liquidModeViewStore.setViewState(state);
};

export const shouldTriggerTranslation = stores =>
  !(stores.liquidModeViewStore.viewState === liquidModeViewState.DEFAULT);
